/** Kontakt z administratorem aplikacji (nie skrzynka transakcyjna SMTP). */
export const APP_NAME = "AgroHodowca";
export const ADMIN_NAME = "Karol Oleksy";
export const CONTACT_EMAIL = "kontakt@agrohodowca.pl";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const ACCOUNT_DELETION_DAYS = 14;
